import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { toMoney } from '../../views/invoice-tool/amount/amount-helper';
import Utils from 'frilans-finans/utils/utils';
import { SalaryTypeConstants } from 'frilans-finans';

export class InvoiceDetailsWorkers extends React.Component {

  static propTypes = {
    invoice: PropTypes.object,
    outlays: PropTypes.array,
    user: PropTypes.object
  };

  outlaysSum () {
    return this.props.outlays.reduce((a, b) => {
      return a + b.amountIncVat;
    }, 0);
  }

  workers () {
    const workers = [];

    this.props.invoice.invoiceUsers.forEach((worker) => {
      let isInvoiceCreator = parseInt(worker.userId) === parseInt(this.props.invoice.userId);

      let gross = null;
      let net = null;
      let allowance = null;
      let travel = null;
      let toPay = null;
      if (this.props.invoice.salaries) {
        const salary = this.props.invoice.salaries
          .find((salary) => salary.userId === worker.userId &&
            [1, 2, 4].includes(salary.categoryId) &&
            salary.typeId === SalaryTypeConstants.REGULAR_TYPE
          );
        if (salary) {
          gross = salary.grossIncTaxAgencyPart();
          net = salary.netIncTaxAgencyPart();
          allowance = salary.allowance;
          travel = salary.travel;
          toPay = salary.toPayIncTaxAgencyPart();
        }
      }

      if (toPay === null) {
        gross = worker.gross ? worker.gross : 0;
        net = worker.net;
        allowance = worker.allowance;
        travel = worker.travel;
        toPay = worker.net + worker.allowance + worker.travel;
      }

      if (isInvoiceCreator) {
        toPay = toPay + this.outlaysSum();
      }

      let email = null;
      let telephone = null;
      if (+this.props.user.id === worker.userId) {
        if (this.props.user.email) {
          email = (<div className='invoice-details-row'>
            <b><Translate content='EMAIL' />: </b>{this.props.user.email}
          </div>);
        }

        if (this.props.user.cellphone) {
          telephone = (<div className='invoice-details-row'>
            <b><Translate content='TELEPHONE_NR' />: </b>{this.props.user.cellphone}
          </div>);
        }
      }

      workers.push(
        <div key={worker.id + worker.firstName}>
          <div
            className='invoice-details-row-container'
          >
            <div className='invoice-details-row-column justify-center padding-left'>
              <div className='invoice-details-title'>{worker.firstName} {worker.lastName}</div>
              <div className='invoice-details-row'>{worker.street}</div>
              <div className='invoice-details-row'>{worker.zip}, {worker.city}</div>
              <div className='invoice-details-row'>{worker.country}</div>
              <div className='invoice-details-row-divider'></div>
              {email}
              {telephone}
            </div>
            <div className='invoice-details-row-column'>
              <div className='invoice-details-row light flex'>
                <div><Translate content='TO_ACCOUNT' /></div>
                <div>{worker.accountClearingNumber} {worker.accountNumber}</div>
              </div>
              <div className='invoice-details-row white flex'>
                <Translate content='SALARY_GROSS' />
                <div className='uppercase'>{Utils.amountWithCurrency(toMoney(gross), 1)}</div>
              </div>
              <div className='invoice-details-row light flex'>
                <div><Translate content='OMR_KEY' /></div>
                <div>{toMoney((1 - (worker.net / worker.gross)) * 100)} %</div>
              </div>
              <div className='invoice-details-row white flex'>
                <Translate content='SALARY_NET' />
                <div className='uppercase'>{Utils.amountWithCurrency(toMoney(net), 1)}</div>
              </div>
              <div className='invoice-details-row light flex'>
                <Translate content='ALLOWANCE' />
                <div className='uppercase'>{Utils.amountWithCurrency(toMoney(allowance), 1)}</div>
              </div>
              <div className='invoice-details-row white flex'>
                <Translate content='TRAVEL_ALLOWANCE' />
                <div className='uppercase'>{Utils.amountWithCurrency(toMoney(travel), 1)}</div>
              </div>
              <div className='invoice-details-row light flex bold'>
                <Translate content='INVOICE_DETAILS_REWARDS_TO_PAY' />
                <div className='uppercase'>{Utils.amountWithCurrency(toMoney(toPay), 1)}</div>
              </div>
            </div>
          </div>
        </div>
      );
    });
    return workers;
  }

  render () {
    let invoice = this.props.invoice;
    if (invoice) {
      return (<div className='invoice-details-part-container'>
        <Translate className='invoice-details-title' content='INVOICE_DETAILS_COMPENSATION' />
        <div className='invoice-details-workers-container'>
          {this.workers()}
        </div>
      </div>);
    }
    return null;
  }
}

export default InvoiceDetailsWorkers;



/** WEBPACK FOOTER **
 ** ./src/components/invoice-details/workers.js
 **/